import Maybe from '@components/Maybe';
import {LoaderComponent} from 'ht-styleguide';

type SpaceProps = {
  verticalM?: number | string;
  verticalD?: number | string;
  loader?: boolean;
  classRef?: string;
};

export const Space = ({verticalM, verticalD, loader}: SpaceProps) => {
  const mobile = typeof verticalM === 'string' ? verticalM.replace('px', '') : verticalM;
  const desktop = typeof verticalD === 'string' ? verticalD.replace('px', '') : verticalD;

  return (
    <div className="spaceAdjustment loader">
      <Maybe condition={Boolean(loader)}>
        <LoaderComponent />
      </Maybe>
      <style jsx>{`
        .spaceAdjustment {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: ${mobile}px;

          @media (min-width: 576px) {
            min-height: ${desktop}px;
          }
        }
      `}</style>
    </div>
  );
};

export default Space;
